import React, { Component } from 'react';
import styled from 'styled-components';

// import circle from './assets/circle.svg';
import mediaWidth from '../../utils/mediaWidth/mediaWidth';

class BlueCircle extends Component {
    render() {
        const { className } = this.props;

        return <Root className={className} />;

        // return (
        //     <Root className={className}>
        //         <Image src={circle} />
        //     </Root>
        // );
    }
}

const Root = styled.div`
    width: 24px;
    height: 24px;

    background-color: #0032A0;
    border-radius: 50%;

    ${mediaWidth.l} {
        width: 32px;
        height: 32px;
    }
`;

// const Image = styled.img`
//     display: block;

//     width: 100%;
//     height: 100%;
// `;

export default BlueCircle;
